<template>
  <div class="sidebar-container">
    <ul class="navbar-nav sidebar">

      <template v-for="link in links">
        <router-link
            :key="link.path" :to="link.path" v-if="checkPermission(link)"
            class="nav-link nav-item"
            :class="{
              'nav-item-active': isActive(link.path),
            }"
>
          <li>
            <i>
              <component :is="link.icon" class="pl-1" size="2.2x"/>
            </i>{{ link.description }}
          </li>

        </router-link>
      </template>

    </ul>
  </div>
</template>
<script>
  import {
    BarChart2Icon,
    CoffeeIcon,
    CalendarIcon,
    GridIcon,
    OctagonIcon,
    SettingsIcon
  } from 'vue-feather-icons'
  
  import GetAccount from '@/mixins/GetAccount'
  import GetUser from '@/mixins/GetUser'

  export default {
    components: { BarChart2Icon, CalendarIcon, CoffeeIcon, GridIcon, OctagonIcon, SettingsIcon },
    data() {
      return {
        links: [
          { description: 'Dashboard', icon: 'BarChart2Icon', path: '/' },
          { description: 'Apps e Marketplace', icon: 'GridIcon', path: '/apps' },
          { description: 'Calendário', icon: 'CalendarIcon', path: '/calendar' },
          { description: 'Definições', icon: 'SettingsIcon', path: '/definitions' },
          { description: 'Unico Integration', icon: 'OctagonIcon', path: '/unico_integration', unicoIntegration: true },
          { description: 'Admin', icon: 'CoffeeIcon', path: '/admin', superUser: true },
        ]
      }
    },
    methods: {
      checkPermission(link) {
        if (link.superUser)
          return this.isSuperUser
        else if (link.path === '/calendar')
          return this.showCalendar()
        else if (link.path === '/apps') {
          return this.showApps()
        } else if (link.unicoIntegration)
          return this.showUnicoIntegration()
        else
          return true
      },
      isActive(pathLink) {
        let path = this.$route.path

        let response
        if (pathLink === '/' && path.includes('/dashboard'))
          response = true
        else if (pathLink === path)
          response = true
        else if (pathLink === '/apps' && path.startsWith('/apps/'))
          response = true
        else if (pathLink === '/admin' && path.startsWith('/admin/'))
          response = true

        return response
      },
      showApps(){
        if (this.getAccount.accountType === 'partner')
          return false
        if (this.getAccount.accountId && !this.getUser.brobotStaff)
          return false
        return true
      },
      showCalendar() {
        const policy = this.$withPolicy('application', 'calendar')
        const notPartner = this.getAccount.accountType !== 'partner'
        return policy && notPartner
      },
      showUnicoIntegration() {
        return this.getAccount.metadata['unicoIntegration'] && this.getUser.role === 'owner'
      },
    },
    mixins: [GetAccount, GetUser],
    name: 'Sidebar',
  }
</script>

<style scoped>
.nav-link {
  color: var(--nav-link-color) !important;
  text-decoration: none !important;
}

.nav-link:hover {
  color: var(--primary-color) !important;
}

.nav-item svg {
  color: var(--icon-color);
}

.nav-item:hover svg,
.nav-item-active svg {
  color: var(--primary-color) !important;
}

.sidebar-container {
  height: 100%;
  overflow-y: auto;
}
</style>
